import React, { Fragment, useEffect, useState } from 'react';
import TrackerService from '../Services/TrackerService';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
export default function GSCChart({ domain, page }) {
    const [data, setData] = useState();
    const [currentFilter, setCurrentFilter] = useState('impressions')
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Google Search Console Data',
            },
        },
    };
    
    useEffect(() => {
        TrackerService.getTracker({ page, domain }).then(c => {
            setData(c.Items);
        }).catch(e => {
            console.log(e)
        })
    }, [])

    const formatData = (data) => {
        const res = {
            labels: data.map(d => d.date),
            datasets: [getDataset(data)]
        }
        return res;
    }

    const getDataset = (data) => {
        switch (currentFilter) {
            case 'impressions':
                return {
                    label: "Impressions",
                    data: data.map(d => d[currentFilter]),
                    borderColor: '#36A2EB',
                    backgroundColor: '#9BD0F5',
                };
            case 'clicks':
                return {
                    label: "Clicks",
                    data: data.map(d => d[currentFilter]),
                    borderColor: '#36A2EB',
                    backgroundColor: '#9BD0F5'
                };
            case 'position':
                return {
                    label: "Position",
                    data: data.map(d => d[currentFilter]),
                    borderColor: '#36A2EB',
                    backgroundColor: '#9BD0F5'
                };
            case 'ctr':
                return {
                    label: "CTR",
                    data: data.map(d => d[currentFilter] * 100),
                    borderColor: '#36A2EB',
                    backgroundColor: '#9BD0F5'
                };
        }

    }

    return data && (<Fragment>
        <div className="flex items-center justify-center">
            <div className="inline-flex shadow-md hover:shadow-lg focus:shadow-lg" role="group">
                <button onClick={() => { setCurrentFilter("impressions") }} disabled={currentFilter === "impressions"} type="button" className={`${currentFilter === "impressions" ? "bg-blue-600 " : "bg-blue-400"} rounded-l inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase hover:bg-blue-700 focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out`}>Impressions</button>
                <button onClick={() => { setCurrentFilter("clicks") }} disabled={currentFilter === "clicks"} type="button" className={`${currentFilter === "clicks" ? "bg-blue-600 " : "bg-blue-400"} inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase hover:bg-blue-700 focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out`}>Clicks</button>
                <button onClick={() => { setCurrentFilter("ctr") }} disabled={currentFilter === "ctr"} type="button" className={`${currentFilter === "ctr" ? "bg-blue-600 " : "bg-blue-400"} inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase hover:bg-blue-700 focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out`}>CTR</button>
                <button onClick={() => { setCurrentFilter("position") }} disabled={currentFilter === "position"} type="button" className={`${currentFilter === "position" ? "bg-blue-600 " : "bg-blue-400"} rounded-r inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase hover:bg-blue-700 focus:bg-blue-700 focus:outline-none focus:ring-0 active:bg-blue-800 transition duration-150 ease-in-out`}>Position</button>
            </div>
        </div>
        <Line data={formatData(data)} options={options} />
    </Fragment>)

}

